<template>
<!-- NOTE (TEMPLATE) to show the proposals archive -->

  <div class="animated fadeIn">

    <b-card
      v-if="$router.currentRoute.path == '/head/archive'"
      style="border:0"
      class="mt-0 mb-0"
    >
      <h6>
        <b-input-group size="md">
          <b-form-input trim 
            v-model="filter"
            type="search"
            id="filterInput"
            placeholder="جستجو"
          ></b-form-input>
          <b-input-group-append>
            <b-button
              :disabled="!filter"
              @click="filter = ''"
              variant="danger"
            >حذف</b-button>
          </b-input-group-append>
        </b-input-group>
      </h6>
      
      <!-- NOTE (t-proposalsArchive) to show the proposals archive list -->
      <b-table
        responsive
        show-empty
        head-variant="dark"
        :fields="fields"
        :items="items"
        empty-text="هنوز طرحی ثبت نشده است"
        striped
        :busy="isBusy"
        :filter="filter"
      >
        <template v-slot:head()="data">
          <div style="text-align:center;vertical-align:middle">{{data.label }}</div>
        </template>
        <template v-slot:cell()="data">
          <div style="text-align:center;vertical-align:middle">{{data.value}}</div>
        </template>
        <div
          slot="table-busy"
          class="text-center text-danger my-2"
        >
        <strong>در حال بارگذاری...</strong>
          <br />
          <b-spinner class="align-middle"></b-spinner>
        </div>
      </b-table>
    </b-card>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  components: {},
  data: function() {
    return {
      fields: [
        { key: 'index', label: 'ترتیب' },
        { key: 'faSubject', label: 'عنوان فارسی' },
        { key: 'project_code', label: 'کد طرح' },
        { key: '', label: 'تاریخ ثبت' },
        { key: 'project_status', label: 'وضعیت' },
        { key: 'university', label: 'دانشگاه' },
        { key: 'last_update', label: 'آخرین بروزرسانی' },
        { key: 'operation', label: 'عملیات' }
      ],
      items: [{ faSubject: 'test1' }, { faSubject: 'test2' }],
      filter: '',
      isBusy: true
    }
  },

  methods: {},

  mounted() {
    this.isBusy = false
  }
}
</script>

<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url('../../assets/fonts/IRANSans(FaNum).ttf');
}
</style>
<style scoped>
.color {
  background-color: #0c4961;
  color: white;
}
</style>
